import { create } from "zustand";
import { pageNavList } from "../constants/pageNav";
// import { inspectionSteps } from "../constants/dataList";

export const usePageNav = create((set) => ({
  current: pageNavList[0],
  list: pageNavList,
  setCurrent: (item) => {
    set({ current: item });
  },
}));

export const useFlashcard = create((set) => ({
  current: 0,
  setCurrent: (e) => set({ current: e }),
}));

export const useAudioSpeed = create((set) => ({
  active: false,
  value: 1,
  list: [
    { value: 0.5 },
    { value: 0.75 },
    { value: 1 },
    { value: 1.25 },
    { value: 1.5 },
    { value: 2 },
  ],
  setValue: (e) => e && set({ value: e }),
  activate: () => set({ active: true }),
  deactivate: () => set({ active: false }),
}));

export const useLoopOnce = create((set) => ({
  active: false,
  activate: () => set({ active: true }),
  deactivate: () => set({ active: false }),
  toggle: () => set((prev) => ({ active: !prev.active })),
}));

export const usePlaylist = create((set) => ({
  active: false,
  // list: inspectionSteps,
  activate: () => set({ active: true }),
  deactivate: () => set({ active: false }),
}));

export const useMultimedia = create((set) => ({}));

export const useAudio = create((set, get) => ({
  audioId: null,
  url: null,

  fetchFromCache: async (id = get().audioId) => {
    const cache = await caches.open("audio");
    const response = await cache.match(`audio-${id}`);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    set({ url, id });
  },
  saveToCache: async (id) => {
    const audioURL = "https://example.com/audio.mp3";
    const response = await fetch(audioURL);
    const cache = await caches.open("audio");
    await cache.put(`audio-${id}`, response);
  },
  setAudioId: async (id) => {
    if (id !== get().audioId) {
      set({ audioId: id, url: null });
    }
    await get().fetchFromCache(id);
  },

  play: async () => {},
}));
